import Transform from '@ember-data/serializer/transform';
import { ObjectId } from 'bson';

export default class ObjectIdTransform extends Transform {
  deserialize(serialized) {
    return serialized;
  }

  serialize(deserialized) {
    return new ObjectId(deserialized);
  }
}
